import axios from "../../../lib/axios";
import { AxiosResponse } from "axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { QData } from "../../../types/basic-type-list";

export interface IFaq {
  _id: string;
  question: string;
  answer: string;
  order?: number;
  status?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface FaqFormValues {
  question: string;
  answer: string;
  order?: number;
  status?: boolean;
}

export async function listFaqs(
  qData?: QData
): Promise<AxiosResponse<TResponseWithQData<IFaq[]>>> {
  return axios.get<TResponseWithQData<IFaq[]>>("/faq", {
    params: qData,
  });
}

export async function createFaq(
  data: FaqFormValues
): Promise<AxiosResponse<TResponse<IFaq>>> {
  return axios.post<TResponse<IFaq>>("/faq", data);
}

export async function updateFaq({
  id,
  data,
}: {
  id: string;
  data: Partial<FaqFormValues>;
}): Promise<AxiosResponse<TResponse<IFaq>>> {
  return axios.put<TResponse<IFaq>>(`/faq/${id}`, data);
}

export async function deleteFaq(
  id: string
): Promise<AxiosResponse<TResponse<IFaq>>> {
  return axios.delete<TResponse<IFaq>>(`/faq/${id}`);
}

export async function getFaqDetail(
  id: string
): Promise<AxiosResponse<TResponse<IFaq>>> {
  return axios.get<TResponse<IFaq>>(`/faq/${id}`);
}
